import { render } from "./LearnHome.vue?vue&type=template&id=72ce056d&scoped=true"
import script from "./LearnHome.vue?vue&type=script&lang=js"
export * from "./LearnHome.vue?vue&type=script&lang=js"

import "./LearnHome.vue?vue&type=style&index=0&id=72ce056d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ce056d"]])

export default __exports__